import { Box, Grid, useTheme } from "@chakra-ui/react";
import React from "react";
import { Outlet } from "react-router-dom";
import { Theme } from "../../theme";
import Navbar from "../../components/Navbar";
import {
  MdOutlineHome,
  MdOutlinePeople,
  MdPointOfSale,
  MdAddCircleOutline,
  MdOutlineDirectionsBike,
  MdDiscount,
  MdMoney,
  MdNotifications,
  MdHome,
  MdHistory,
  MdMap,
  MdOutlineReviews,
  MdOutlineAutoGraph,
  MdOutlineWidgets,
} from "react-icons/md";

import { Topbar } from "../../components/Topbar";

const Index = () => {
  const theme = useTheme<Theme>();

  const data = [
    {
      name: "Home",
      img: MdHome,
      path: "/",
      item: [
        {
          name: "Home",
          item: [
            {
              item_name: "Overview",
              path: "",
            },
            {
              item_name: "Ride Fare",
              path: "ride-fare",
            },
          ],
        },
      ],
    },
    {
      name: "Drivers",
      img: MdOutlineDirectionsBike,
      path: "/drivers",
      item: [
        {
          name: "Drivers",
          item: [
            {
              item_name: "Driver List",
              path: "drivers",
            },
            {
              item_name: "Blocked",
              path: "drivers/blocked",
            },
            {
              item_name: "Waiting Approval",
              path: "drivers/approval",
            },
            {
              item_name: "Recent Earnings",
              path: "drivers/upcoming_payment",
            },
            {
              item_name: "Pending Payment",
              path: "drivers/pending_payment",
            },
          ],
        },
      ],
    },
    {
      name: "Users",
      img: MdOutlinePeople,
      path: "/users",
      item: [
        {
          name: "Users",
          item: [
            {
              item_name: "User List",
              path: "users",
            },
          ],
        },
      ],
    },
    {
      name: "Daily Activities",
      img: MdOutlineAutoGraph,
      path: "/ride-history",
      item: [
        {
          name: "Daily Activities",
          item: [
            {
              item_name: "Ride History",
              path: "ride-history",
            },
            {
              item_name: "Parcel History",
              path: "parcel-history",
            },
            {
              item_name: "App Activities",
              path: "activities",
            },
          ],
        },
      ],
    },
    // {
    //   name: "Ride History",
    //   img: MdHistory,
    //   path: "/ride-history",
    //   item: [
    //     {
    //       name: "Ride History",
    //       item: [
    //         {
    //           item_name: "List",
    //           path: "ride-history",
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      name: "Incentives",
      img: MdOutlineWidgets,
      path: "/incentives",
      item: [
        {
          name: "Incentives",
          item: [
            {
              item_name: "Overview",
              path: "incentives",
            },
            {
              item_name: "Create Peak Hour",
              path: "incentives/create-peak-hour",
            },
            {
              item_name: "Incentive Summary",
              path: "incentives/summary",
            },
          ],
        },
      ],
    },
    {
      name: "Area",
      img: MdMap,
      path: "/area",
      item: [
        {
          name: "area",
          item: [
            {
              item_name: "Driver List",
              path: "area",
            },
            {
              item_name: "Assign Driver Area",
              path: "assign-driver-area",
            },
            {
              item_name: "List Areas",
              path: "list-areas",
            },
          ],
        },
      ],
    },
    {
      name: "Notification",
      img: MdNotifications,
      path: "/notification/all",
      item: [
        {
          name: "Notification",
          item: [
            {
              item_name: "Notification List",
              path: "notification/all",
            },
            {
              item_name: "Create",
              path: "notification/create",
            },
          ],
        },
      ],
    },
    {
      name: "Advertisements",
      img: MdPointOfSale,
      path: "/advertisement",
      item: [
        {
          name: "Advertisements",
          item: [
            {
              item_name: "Advertisement List",
              path: "advertisement",
            },
            {
              item_name: "Create",
              path: "advertisement/create",
            },
          ],
        },
      ],
    },
    {
      name: "Coupons",
      img: MdDiscount,
      path: "/coupons",
      item: [
        {
          name: "Coupons",
          item: [
            {
              item_name: "Coupon List",
              path: "coupons",
            },
            {
              item_name: "Create",
              path: "coupons/create",
            },
          ],
        },
      ],
    },
    {
      name: "Review & Feedbacks",
      img: MdOutlineReviews,
      path: "/driver-reviews",
      item: [
        {
          name: "Driver Reviews",
          item: [
            {
              item_name: "Driver Reviews",
              path: "driver-reviews",
            },
          ],
        },
        {
          name: "User Feedback",
          item: [
            {
              item_name: "User Feedback",
              path: "user-feedbacks",
            },
          ],
        },
      ],
    },
    {
      name: "Create Admin",
      img: MdAddCircleOutline,
      path: "/admin",
      item: [
        {
          name: "Create Admin",
          item: [
            {
              item_name: "Admin List",
              path: "admin",
            },
            {
              item_name: "Create",
              path: "admin/create",
            },
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Grid w={"100%"} height={"100vh"} gridTemplateColumns={"15rem 1fr"}>
        <Box
          backgroundColor="#FFFFFF"
          borderRight="1px solid"
          borderColor={theme.colors.divider}
          sx={{ height: "100%" }}
        >
          <Navbar data={data} isCMS={false} />
        </Box>
        <Grid backgroundColor="#fbf4f4" gridTemplateRows={"5.4rem 1fr"}>
          <Box
            height="5.4rem"
            borderBottom="1px solid"
            borderColor={theme.colors.divider}
          >
            <Topbar />
          </Box>
          <Box>
            <Box
              sx={{
                // paddingLeft: "12.5rem",
                overflowY: "scroll",
                maxHeight: "calc(100vh - 5.4rem)",

                //@ts-ignore
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  borderRadius: "2px",
                  background: theme.colors.secondary.light,
                },
              }}
            >
              <Box
                sx={{
                  paddingBottom: theme.space["4xl"],
                }}
              >
                <Outlet />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* <p style={{ color: "red", fontSize: "24px" }}>Layout</p>
            <Outlet /> */}
    </>
  );
};

export default Index;
